import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "", role: "patient" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created");
      nav(res.data.role === "patient" ? "/portal" : "/dashboard");
    } else toast.error(res.error);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[color:var(--bg-marketing)] p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[color:var(--border)] rounded-2xl p-8" data-testid="register-form">
        <h2 className="font-heading text-3xl font-medium text-[color:var(--ink)] mb-1">Create your patient account</h2>
        <p className="text-sm text-[color:var(--muted)] mb-7">Track prescriptions, appointments and case history.</p>
        <div className="space-y-4">
          <Field label="Full name" value={form.name} onChange={v => setForm({...form, name: v})} testid="register-name" />
          <Field label="Email" type="email" value={form.email} onChange={v => setForm({...form, email: v})} testid="register-email" />
          <Field label="Phone" value={form.phone} onChange={v => setForm({...form, phone: v})} testid="register-phone" />
          <Field label="Password" type="password" value={form.password} onChange={v => setForm({...form, password: v})} testid="register-password" />
        </div>
        <Button type="submit" disabled={loading} className="w-full mt-6 rounded-full bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-white h-11" data-testid="register-submit">
          {loading ? "Creating…" : "Create account"}
        </Button>
        <p className="mt-5 text-sm text-[color:var(--muted)] text-center">
          Already have an account? <Link to="/login" className="text-[color:var(--primary)] hover:underline font-medium" data-testid="register-login-link">Sign in</Link>
        </p>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="text-xs font-semibold tracking-wider uppercase text-[color:var(--muted)]">{label}</label>
      <Input required type={type} value={value} onChange={e => onChange(e.target.value)} className="mt-2" data-testid={testid} />
    </div>
  );
}
